import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['nav'];

  connect() {
    let lastScroll = 0;
    let isHidden = false;

    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY;

      if (currentScroll > lastScroll && currentScroll > 250 && !isHidden) {
        // Scrolling down past 100px
        this.navTarget.classList.add('-translate-y-40');
        isHidden = true;
      } else if (currentScroll < lastScroll && isHidden) {
        // Scrolling up
        this.navTarget.classList.remove('-translate-y-40');
        isHidden = false;
      }

      lastScroll = currentScroll; // Update last scroll position
    });
  }
}
